import React from 'react';
import Icon from '../AppIcon';

const MobileMenuButton = ({ onClick, isOpen }) => {
  return (
    <button
      onClick={onClick}
      className="mobile-menu-button"
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
    >
      <Icon name={isOpen ? 'X' : 'Menu'} size={24} />
    </button>
  );
};

export default MobileMenuButton;